import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { sendCmd } from '@/api/apis';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      groupList: [{
        key: 'B49981660',
        value: '义系-贾红英'
      }, {
        key: 'B78869475',
        value: '义系-刘春梅'
      }, {
        key: 'B57674849',
        value: '智系-孙肖'
      }, {
        key: 'B27917835',
        value: '信系-王树颖'
      }, {
        key: 'B24586540',
        value: '礼系-徐敏'
      }, {
        key: 'B72260199',
        value: '仁系-黄金库'
      }, {
        key: 'B84167861',
        value: '礼系-周建申'
      }],
      form: {
        numbers: 'B88888888',
        groups: [],
        year: '',
        month: ''
      },
      rules: {
        year: [{
          require: true,
          validator: this.$tempModel.rules.integer.validator,
          trigger: 'blur'
        }],
        month: [{
          require: true,
          validator: this.$tempModel.rules.integer.validator,
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    for (var i in this.groupList) {
      this.form.groups.push(this.groupList[i].key);
    }
  },
  methods: {
    show: function show(finish) {
      this.dialogVisible = true;
      this.finish = finish;
    },
    clickImport: function clickImport() {
      this.$refs.import.value = null; //解决change事件在同一个文件下不触发的问题

      this.$refs.import.click();
    },
    onExcelImport: function onExcelImport(event) {
      var _this = this;

      var file = event.target.files[0];
      this.$import.xlsx(file).then(function (_ref) {
        var header = _ref.header,
            results = _ref.results;

        if (results.length === 0) {
          return;
        }

        if (!results[0].hasOwnProperty('会员编号')) {
          _this.$alert('请添加"会员编号"列', '提示', {
            confirmButtonText: '确定',
            callback: function callback(action) {}
          });

          return;
        }

        var tmp = [];

        for (var i in results) {
          tmp.push(results[i]['会员编号']);
        }

        _this.form.numbers = tmp.join(',');
      }); // 阻止默认的上传

      return false;
    },
    clickSubmit: function clickSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          sendCmd(['stabigv', '-numbers', _this2.form.numbers, '-groups', _this2.form.groups.join(','), '-year', _this2.form.year, '-month', _this2.form.month]).then(function _callee(res) {
            var msg;
            return regeneratorRuntime.async(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this2.totalCount = _this2.form.numbers.split(',').length;
                    msg = '命令执行成功，请稍后再次刷新列表';

                    if (_this2.totalCount > 1) {
                      msg = '命令执行成功，将要计算' + _this2.totalCount + '个会员，预计用时' + _this2.totalCount * 5 + '秒，请稍后再次刷新列表';
                    }

                    _this2.$alert(msg, '提示', {
                      confirmButtonText: '确定',
                      callback: function callback(action) {
                        _this2.dialogVisible = false;

                        _this2.finish();
                      }
                    });

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            });
          });
        }
      });
    }
  }
};